import { RootState, useSelector } from '@tabeeb/store'
import { AnnotationResponse } from '@tabeeb/contracts/main-api/swagger-main-api'
import { getAnnotationById } from '../selectors'

export function useAnnotationById(id: number): AnnotationResponse | undefined {
  return useSelector((state: RootState) => getAnnotationById(state, { Id: id }))
}
export default useAnnotationById
